import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import ScheduleCell from '../cell';
import './row.scss';

import { SCHEDULE_CELL_TYPE, scheduleCellTypes } from '../../constants';

class Row extends PureComponent {
  constructor(props) {
    super(props);

    this.CLASS_NAME = 'brzw-calendar-row';

    this.state = {
      expanded: props.expandAllFlag,
    };

    this.onExpandTriggerClick = this.onExpandTriggerClick.bind(this);
    this.renderRowChildren = this.renderRowChildren.bind(this);
    this.renderExpandTrigger = this.renderExpandTrigger.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { expandAllFlag: nextExpandAllFlag } = nextProps;

    const { expandAllFlag } = this.props;
    const { expanded } = this.state;

    if (nextExpandAllFlag !== expandAllFlag && nextExpandAllFlag !== expanded) {
      this.setState({
        expanded: nextExpandAllFlag,
      });
    }
  }

  onExpandTriggerClick() {
    const { expandAllMode, setExpandAll } = this.props;

    const { expanded } = this.state;

    if (expandAllMode) {
      setExpandAll(!expanded);
    } else {
      this.setState({
        expanded: !expanded,
      });
    }
  }

  renderRowChildren() {
    const { children, expandCellProps, rowHasReservations } = this.props;

    const { expanded } = this.state;

    let extendedChildren = [];

    if (expandCellProps.hidden) {
      extendedChildren = _.flatten(_.concat([], children));
    } else {
      extendedChildren = _.flatten(_.concat([], this.renderExpandTrigger(), children));
    }

    const childrenSize = _.size(extendedChildren);
    const childrenSizeIndexed = childrenSize - 1;
    let shouldDetectFirstData = true;

    return React.Children.map(extendedChildren, (child, childIndex) => {
      const isDataChild = _.get(child, 'props.type') === SCHEDULE_CELL_TYPE.DATA;
      const firstDataInRow = shouldDetectFirstData && isDataChild;

      const extendedProps = {
        firstInRow: childIndex === 0,
        lastInRow: childIndex === childrenSizeIndexed,
        expandedRow: expanded,
        expandRow: this.onExpandTriggerClick,
        zIndex: childrenSize - childIndex,
        firstDataInRow,
        rowHasReservations,
      };

      if (firstDataInRow) {
        shouldDetectFirstData = false;
      }

      return React.cloneElement(child, extendedProps);
    });
  }

  renderExpandTrigger() {
    const { expandCellProps } = this.props;
    const { expanded } = this.state;

    const buttonClassName = classnames(`${this.CLASS_NAME}__expand-trigger`, {
      [`${this.CLASS_NAME}__expand-trigger--expanded`]: expanded,
      [`${this.CLASS_NAME}__expand-trigger--collapsed`]: !expanded,
    });

    return (
      <ScheduleCell
        type={SCHEDULE_CELL_TYPE.EXPAND}
        compact
        disableTrigger
        disablePropagation
        {...expandCellProps}
      >
        <button type="button" className={buttonClassName} onClick={this.onExpandTriggerClick} />
      </ScheduleCell>
    );
  }

  render() {
    const {
      containerClassName: propsContainerClassName,
      decorated,
      firstRow,
      lastRow,
      rowRef,
      rowType,
      scheduleMode,
      sticky,
    } = this.props;

    const { expanded } = this.state;

    const containerClassName = classnames(
      this.CLASS_NAME,
      propsContainerClassName,
      `${this.CLASS_NAME}--${rowType}`,
      {
        [`${this.CLASS_NAME}--expanded`]: expanded,
        [`${this.CLASS_NAME}--sticky`]: sticky,
        [`${this.CLASS_NAME}--decorated`]: decorated,
        [`${this.CLASS_NAME}--first-row`]: firstRow,
        [`${this.CLASS_NAME}--last-row`]: lastRow,
        [`${this.CLASS_NAME}--${scheduleMode}`]: scheduleMode,
      },
    );

    if (lastRow) {
      return (
        <div className={containerClassName} ref={rowRef}>
          <div className={`${this.CLASS_NAME}__wrapper`}>{this.renderRowChildren()}</div>
        </div>
      );
    }

    return (
      <div className={containerClassName}>
        <div className={`${this.CLASS_NAME}__wrapper`}>{this.renderRowChildren()}</div>
      </div>
    );
  }
}

Row.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  containerClassName: PropTypes.string,
  decorated: PropTypes.bool,
  expandAllFlag: PropTypes.bool,
  expandAllMode: PropTypes.bool,
  expandCellProps: PropTypes.shape({
    hidden: PropTypes.bool,
  }),
  firstRow: PropTypes.bool,
  heading: PropTypes.bool,
  lastRow: PropTypes.bool,
  rowHasReservations: PropTypes.bool,
  rowRef: PropTypes.shape({}),
  rowType: PropTypes.oneOf(scheduleCellTypes),
  scheduleMode: PropTypes.string,
  setExpandAll: PropTypes.func,
  sticky: PropTypes.bool,
};

Row.defaultProps = {
  children: [],
  containerClassName: '',
  decorated: false,
  expandAllFlag: false,
  expandAllMode: false,
  expandCellProps: {
    hidden: false,
  },
  firstRow: false,
  heading: false,
  lastRow: false,
  rowHasReservations: false,
  rowType: SCHEDULE_CELL_TYPE.DATA,
  scheduleMode: '',
  setExpandAll: () => {},
  sticky: false,
};

export default Row;
